export default __webpack_public_path__ + "static/miradorBiodiversidad-a7313722d587bdb0b26edab88bf145c1.jpg";